import { render } from "./AkCheckboxButton.vue?vue&type=template&id=d402c1aa"
import script from "./AkCheckboxButton.vue?vue&type=script&lang=js"
export * from "./AkCheckboxButton.vue?vue&type=script&lang=js"

import "./AkCheckboxButton.vue?vue&type=style&index=0&id=d402c1aa&lang=css"

import exportComponent from "/root/dirif/preprod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__